import { SitePlanFilterDataTypes, SitePlanFilterTypes } from '../../types';
import { SitePlanFilterResponseTypes } from '../../types/response';

export const convertSitePlanFilterResponse = (
  item: SitePlanFilterResponseTypes
): SitePlanFilterTypes => {
  const {
    aliases = [],
    bedrooms: bedroom = [],
    directions: direction = [],
    floors = [],
    squares = [],
    floorNumbers = [],
  } = item;
  const filterFloorData: SitePlanFilterDataTypes[] = floors.map((x) => ({
    key: `${x.first}`,
    value: Number(x.second),
  }));
  const filterItemCodeData: SitePlanFilterDataTypes[] = aliases.map((x) => ({
    key: `${x.first}`,
    value: x.second,
  }));
  const filterSquareData: number[] = squares.map((x) => Number(x));
  const filterFloorNumberData: number[] = floorNumbers.map((x) => Number(x));
  return {
    bedroom,
    direction,
    floorNumber: filterFloorNumberData,
    square: filterSquareData,
    floor: filterFloorData,
    itemCode: filterItemCodeData,
  };
};
